// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/dialog/index.css
// module id = 1770
// module chunks = 148